import React, { Fragment, useContext, useEffect } from "react";

import AuthContext from "../../context/auth/authContext";
import PostComposerV2 from "../posts/PostComposerV2";
import Posts from "../posts/Posts";

import Grid from '@mui/material/Grid2';
import { makeStyles } from "@material-ui/core/styles";
import TagsNavigator from "../layout/TagsNavigator";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  sidebar: {
    [theme.breakpoints.down("sm")]: { display: "none" },
  },
}));

function useQuery() {
  return new URLSearchParams(window.location.search);
}

const Memory = () => {
  const authContext = useContext(AuthContext);
  const { loadUser } = authContext;

  const classes = useStyles();

  const tags = useQuery().get("tags");

  useEffect(() => {
    loadUser();
    // eslint-disable-next-line
  }, []);

  return (
    <Fragment>
      <br />
      <br />
      <div className={classes.root}>
        <Grid container>
          <Grid size={{ xs: 0, sm: 1, lg: 4 }}></Grid>
          <Grid size={{ xs: 12, sm: 10, lg: 4 }}>
            <PostComposerV2 />
            <br />
            <Posts tags={tags} />
          </Grid>
          <Grid size={{ xs: 0, sm: 1, lg: 4 }} sx={{ display: { xs: 'none', sm: 'block' } }}>
            <br />
            <br />
            <div className={classes.sidebar}>
              <TagsNavigator currentTags={tags} />
            </div>
          </Grid>
        </Grid>
      </div>
    </Fragment>
  );
};

export default Memory;
